import { Partner } from '@/types'; // Import the Partner type

export function defaultValues(partner?: Partner) {
  return {
    id: partner?.id || '',
    name: partner?.name || '',
    subTitle: partner?.subTitle || '',
    description: partner?.description || '',
    image: partner?.image || '',
    createdDate: partner?.createdDate || new Date().toISOString(),
    createdUser: partner?.createdUser || '',
  } as Partner;
}
